<template>
  <div :style="$vuetify.breakpoint.smAndDown && 'margin-top: -2em;'">
    <v-layout row wrap>
      <!-- CAROUSEL POSTS -->
      <v-flex md8>
        <CarouselPostsMobile v-if="$vuetify.breakpoint.smAndDown" />
        <CarouselPosts v-else />
      </v-flex>
      <!-- WELCOMES BIRTHDAYS AND BIRTHS  -->
      <v-flex md4>
        <Celebrations />
      </v-flex>
    </v-layout>

    <!-- SECTIONS -->
    <!-- <v-layout row wrap>
      <v-flex md12>
        <SectionsTop />
      </v-flex>
    </v-layout> -->

    <!-- LINKS -->
      <!-- <CarouselLinksMobile v-if="$vuetify.breakpoint.smAndDown" />
      <CarouselLinks v-else /> -->
    <!-- END LINKS -->

    <!-- Banners -->
    <v-layout row wrap>
      <v-flex xs12 md12 my-2>
        <Banners  />
      </v-flex>
    </v-layout>
    <!-- MOMENTOS SECURITY -->
    <v-layout row wrap>
      <v-flex md12>
        <carousel-moments />
      </v-flex>
    </v-layout>
    <!-- SECTIONS -->
    <v-layout row wrap>
      <v-flex md12>
        <SectionsBottom />
      </v-flex>
    </v-layout>
    <!-- Footer -->
    <v-flex v-if="result[0] == 'ie'">
      <footer-home />
    </v-flex>
  </div>
</template>
<script>
import { mapState } from "vuex";
import FooterHome from "@/components/General/FooterHome";
import CarouselMoments from "./CarouselMoments";
import Celebrations from "./Celebrations";
import CarouselLinks from "./CarouselLinks";
import CarouselLinksMobile from "./CarouselLinksMobile";
import SectionsBottom from "./SectionsBottom";
import SectionsTop from "./SectionsTop";
import Banners from './Banners.vue';
import BannersMobile from './BannersMobile.vue';
export default {
  components: {
    FooterHome,
    CarouselMoments,
    Celebrations,
    CarouselLinks,
    CarouselLinksMobile,
    SectionsBottom,
    SectionsTop,
    Banners,
    BannersMobile,
  },
  data() {
    return {
      result: [],
      windowWidth: screen.width
    };
  },
  mounted() {
    this.browser_detect();
    // Manda el scroll al inicio cada vez que se cambia de ruta
    window.scrollTo(0, 0);
  },
  methods: {
    browser_detect() {
      let ua = window.navigator.userAgent;
      let ms_ie = /MSIE|Trident/.test(ua);
      if (ms_ie) {
        this.result.push("ie");
      } else {
        this.result.push("otro");
      }
    }
  },
  computed: {
    ...mapState("user", ["current_user"])
  },
};
</script>

<style>
/* headlines with lines */
.btn-hover:hover {
  background: #789c4a !important;
  border-color: #789c4a !important;
  color: white;
}
.v-carousel__controls {
  background: transparent !important;
}
.v-btn.v-btn--icon.v-btn--small.theme--light.v-carousel__controls__item {
  color: white;
}
.v-icon.fas.fa-circle.theme--light {
  opacity: inherit;
}
.v-btn--active:before,
.v-btn:hover:before,
.v-btn:focus:before {
  background-color: transparent;
}
.flex_fix {
  margin-left: -4%;
}

.section {
  background: rgba(0, 0, 0, 0.5);
}
.gallery-carousel:nth-child(2) {
  margin: 0 45px;
}
.created_at {
  color: white;
  margin-left: 2%;
  font-weight: 600;
}
.pt-8 {
  padding-top: 36px !important;
}
.scroll {
  overflow-x: auto;
}

.v-tabs__item:not(.v-tabs__item--active) {
  font-size: 14px;
  color: #8c8c8c;
}
.v-tabs__item--active {
  color: #28385C !important;
  font-size: 14px;
  max-width: 120px !important;
  font-weight: 700;
  padding: 0 !important;
}

.v-tabs__container {
  height: 25px;
}
.v-tabs__div {
  -webkit-box-align: baseline;
  -ms-flex-align: baseline;
  align-items: baseline;
}
.v-tabs__item:hover {
  text-decoration: none !important;
}
.v-tabs__slider {
  height: 0px;
}
</style>
